<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from "@/utils/uiWrapper";
import FooterViewOld from "./Old/OldTabContentView.vue";
import NewFooterView from "./New/NewTabContentView.vue";

const current = useUiWrapper(FooterViewOld, NewFooterView);
</script>
